import {SearchInputAreaCasino888WsopBox} from "./search-input-area.casino888Wsop.box";

export const SearchInputAreaWsopBox = SearchInputAreaCasino888WsopBox;
